import { doQuery } from '@/shared/helpers/clqlHelpers.js';

export type CodeColumn = {
    field: string;
    valueIdx: number;
    type: string;
};

export type CodeItemRow = { value: string; name?: string }[];

export type FilterFunc = (row: CodeItemRow) => boolean;

const createRegexFilterFunc = (regex: string, columns: CodeColumn[]): FilterFunc | undefined => {
    if (columns.length === 0) return;
    const nameIdx = columns.find(c => c.field === 'name')!.valueIdx;
    const descIdx = columns.find(c => c.field === 'description')!.valueIdx;
    return row =>
        row[nameIdx].value.toLowerCase().includes(regex.toLowerCase())
        || row[descIdx].value?.toLowerCase().includes(regex.toLowerCase())
        || !!row[nameIdx].value.match(new RegExp(regex));
};

const createQueryFilterFunc = (queryFrags: string[], columns: CodeColumn[]): FilterFunc | undefined => {
    if (columns.length === 0) return;
    const col = columns.find(c => c.field === queryFrags[0]);
    if (!col) return;
    const attributeType = col.type;
    const valueIdx = col.valueIdx;
    return row =>
        doQuery(
            attributeType,
            queryFrags[1],
            queryFrags[2],
            attributeType === 'CODEREF' && queryFrags[1] === 'like'
                ? row[valueIdx].name
                : row[valueIdx].value
        );
};

export const generateFilters = (regexs: string[], queries: string[][], columns: CodeColumn[]): FilterFunc[] => {
    const filters: FilterFunc[] = [];
    for (let i = 0; i < regexs.length; i++) {
        const f = createRegexFilterFunc(regexs[i], columns);
        if (f) {
            filters.push(f);
        }
    }
    for (let i = 0; i < queries.length; i++) {
        const f = createQueryFilterFunc(queries[i], columns);
        if (f)
            filters.push(f);
    }
    return filters;
};
